/**
 * @author    Stefano <stefano@blueberry.nl>
 * @since     26-06-2018
 * @class     NavigationController
 */
import Utils from "../utils/Utils";

export const STATECHANGEEVENT = "STATECHANGE";
export default class NavigationController {
    /**
     * Replace the current history entry instead of adding one.
     * Use this when the browser already created the entry for this url,
     * e.g. on the initial page load, so back() does not land on a duplicate.
     * @param historyObj
     * @param title
     * @param url
     */
    static replaceState(historyObj, title, url) {
        NavigationController.pushState(historyObj, title, url, true);
    }

    /**
     * Prevent a url delegate loop on fast crazy clicks
     * A debounce or throttle should me made here for now this works
     * @param historyObj
     * @param title
     * @param url
     * @param replace replace the current entry instead of pushing a new one
     */
    static pushState(historyObj, title, url, replace = false) {
        clearTimeout(window._timeout);
        var later = function () {
            if (window.replaceables) {
                NavigationController._doNavigation(historyObj, title, url + location.search, replace);
            } else {
                NavigationController._doNavigation(historyObj, title, url, replace);
            }
        };

        window._timeout = setTimeout(later, 1); // waiting 1 ms after executing the next navigation
    }

    static _doNavigation(historyObj, title, url, replace = false) {
        if (window.frontend?.gatedContent?.hasActiveGate?.()) {
            return false;
        }
        const updateUrl = window.exportType !== "ipad" && !Utils.hasHashBinding() && window.historyState !== "disabled";

        if (window.exportType === "ipad" || Utils.isDownloaded() || Utils.hasHashBinding()) {
            window._pathname = url.split("/").splice(1);

            if (Utils.isEmpty(window._history)) {
                window._history = [];
            }
            //keep history
            if (window._history.length === 0 || window._history[window._history.length - 1].url !== url) {
                window._history.push({ title: title, url: url });
            }

            try {
                let checkUrl = window.frontend.dataHelper.getUrlList()[window._pathname.join("/")];
                if (checkUrl && Object.hasOwn(checkUrl, "spread_id")) {
                    Utils.setLocationHash(checkUrl.spread_id);
                    if (!Utils.hasHashBinding() || Utils.isDownloaded()) {
                        window.frontend.gotoSpread(checkUrl.spread_id);
                    }
                }
            } catch (e) {
                console.warn("OfflineErr: ", e);
            }
        }

        if (updateUrl) {
            if (window.urlOffset) {
                url = "/" + window.urlOffset + url;
            }
            if (replace) {
                history.replaceState(historyObj, "", url);
            } else {
                history.pushState(historyObj, "", url);
            }
            window.dispatchEvent(new CustomEvent(STATECHANGEEVENT)); //, { detail: { key: value } }
        }
        window.frontend.setDocumentTitle();
    }

    /**
     * @static
     * Navigation back into history
     */
    static historyBack() {
        if (window.exportType === "ipad" || Utils.isDownloaded()) {
            //pop last 2 states and go the the second-last (first in the array);
            var removed = window._history.splice(-2, 2);
            if (removed.length == 2) {
                this.pushState({}, removed[0].title, removed[0].url);
                return parseInt(removed[0].url.split("/").splice(1)[2]);
            }
        } else {
            history.back();
        }
    }
    static getGetParams() {
        let params = location.search.substr(1).split("&");
        let get = {};
        if (params.length > 0 && params != "") {
            for (var i in params) {
                let keyvalue = params[i].split("=");
                get[keyvalue[0]] = keyvalue[1];
            }
        }
        return get;
    }
    /**
     * Get a value from the pathname ( window.location.pathname || this._pathname )
     *
     * @method getPathname
     * @return {Mixed}
     */
    static getPathname(index) {
        var pathname, clone;
        if (window.exportType === "ipad") {
            pathname = window._pathname || [window.offline_language, "overview.html"];
        } else {
            pathname = window.location.pathname.split("/").splice(1); // remove the first empty value

            // .filter(function(n){
            //     return n; // filter empty values.
            // });
        }
        clone = pathname.slice(); //empty slice to clone the original

        if (arguments.length > 0) {
            return clone[index];
        }
        return clone;
    }
}
